interface WaveDividerProps {
  fromColor: string;
  toColor: string;
  className?: string;
}

const WaveDivider = ({ fromColor, toColor, className = "" }: WaveDividerProps) => {
  return (
    <div className={`relative w-full ${className}`} style={{ height: '80px' }}>
      <svg
        className="absolute bottom-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 1440 120"
        preserveAspectRatio="none"
      >
        <path
          d="M0,64 C240,90 480,100 720,85 C960,70 1200,45 1440,64 L1440,120 L0,120 Z"
          fill={toColor}
          className="transition-all duration-300"
        />
      </svg>
    </div>
  );
};

export default WaveDivider;
